import { defineRecipe } from '@chakra-ui/react';

const sidebar = {
  display: 'flex',
  alignItems: 'center',
  height: '56px',
  pl: 6,
  pr: 2,
  py: 2,
  color: 'gray.500',
  lineHeight: 1.5,
  outline: 'none',
  transition: 'none',
  textDecoration: 'none',
  _focus: {
    boxShadow: 'none',
  },
  _hover: {
    color: 'primary.500',
    textDecoration: 'none',
  },
  '&.active': {
    color: 'primary.500',
    fontWeight: 'semibold',
  },
} as const;

const linkRecipe = defineRecipe({
  base: {
    color: 'blue.500',
    textDecoration: 'underline',
    transition: 'none',
    _hover: {
      color: 'orange.500',
    },
  },
  variants: {
    variant: {
      // v3's stock link recipe defaults to variant "plain", which sets
      // `color: colorPalette.fg`, and a variant beats the recipe base, so an
      // unvariated <Link> rendered near-black while the base _hover (which
      // "plain" doesn't set) still applied. Restating the colour here puts it
      // back on the winning side — same fix as ui-core's link recipe.
      plain: {
        color: 'blue.500',
        textDecoration: 'underline',
        _hover: {
          color: 'orange.500',
        },
      },
      sidebar,
      // Same as sidebar but only when the route matches exactly, not for a
      // child sub-route match. A separate variant instead of a prop to get
      // around React complaining about an unrecognized dom attribute.
      sidebarExact: {
        ...sidebar,
        '&.active': {
          ...sidebar['&.active'],
          boxShadow: 'inset 3px 0 0 0 {colors.primary.500}',
        },
      },
      subNavigation: {
        display: 'block',
        pl: 10,
        mb: 3,
        color: 'gray.900',
        lineHeight: 'shorter',
        fontSize: 'sm',
        outline: 'none',
        transition: 'none',
        textDecoration: 'none',
        _focus: {
          boxShadow: 'none',
        },
        _hover: {
          color: 'primary.500',
          textDecoration: 'none',
        },
        '&.active': {
          color: 'primary.500',
          boxShadow: 'inset 3px 0 0 0 {colors.primary.500}',
          fontWeight: 'semibold',
        },
      },
      // v2 read colorScheme/size from props; colorPalette replaces the colour
      // axis and the font size collapses to the md fallback
      navlink: {
        color: 'gray.500',
        fontWeight: 'normal',
        textDecoration: 'none',
        fontSize: 'md',
        _hover: {
          color: 'colorPalette.500',
          textDecoration: 'none',
        },
        '&.active': {
          color: 'colorPalette.500',
        },
      },
    },
  },
});

export default linkRecipe;
